(function (menuView, $) {
  var menuButton;
  var menuHolder;
  var menuIsVisible = false;
  var ignoreClicks = false;

  menuView.init = function () {
    menuHolder = $("#menu-holder");
    menuButton = $("#menu-button");
    menuView.view = $("#menu");

    wireEvents();
  };

  function wireEvents() {
    menuButton.click(function () {
      if (ignoreClicks) {
        return;
      }

      if (menuIsVisible) {
        animateOutMenu(true);
        return;
      }
      animateInMenu();
    });

    menuButton.mouseenter(function () {
      animateInMenu();
      ignoreClicks = true;
      setTimeout(function () {
        ignoreClicks = false;
      }, 1200);
    });

    menuHolder.mouseleave(function () {
      animateOutMenu();
    });

    menuHolder.delegate("a", "click", function () {
      animateOutMenu(true);
    });
  }

  function animateInMenu() {
    menuIsVisible = true;
    el.bodyElement.addClass("menu-visible");
  }

  function animateOutMenu() {
    menuIsVisible = false;
    el.bodyElement.removeClass("menu-visible");
  }
})((window.el.MenuView = window.el.MenuView || {}), jQuery);
